// @ts-ignore
import AmpersandEvents from 'ampersand-events';
import getStackTrace from "../utils/misc/get-stack-trace"

const debug = {
    monitor         : false,
    trigger         : false,
    subscribe       : false,
    head            : "@EventsBus"
};

const debugEvents = false

type DebugEntry = {
    moment      : string
    eventName   : string
    caller      : string
    subscriber  : any
}

export default class EventsBus {

    private emmiter             : any
    private debouncedEvents     : any

    private debugEventsMap      : any = {}
    private diffMapIterations   : any[] = []
    private debugEntries        : DebugEntry[] = []

    constructor() {
        this.emmiter = AmpersandEvents.createEmitter();
        this.debouncedEvents = {};
    }

    triggerEvent(eventName:string,...params:any) {
        if (debug.monitor || debug.trigger) console.log(debug.head,".trigger event=",eventName,"params=",...params);
        this.emmiter.trigger(eventName,...params);
    }

    triggerEventDebounced(eventName:string,params:any) {
        if (!this.debouncedEvents[eventName]) this.debouncedEvents[eventName] = _.debounce(this.triggerEvent.bind(this), 10);
        this.debouncedEvents[eventName](eventName,params)
    }

    subscribeNoContext(eventName:string, callback:func) {
        if (debug.monitor || debug.subscribe) console.log(debug.head,".subscribe on event=",eventName)

        this.emmiter.on(eventName, callback, null)
        this._addToSubscribersLog()

        return () => {
            this.emmiter.off(eventName, callback)
            this._removeFromSubscribersLog()
        }
    }

    subscribe(eventName:string,context:any,callback:func) {
        if (debug.monitor || debug.subscribe) console.log(debug.head,".subscribe on event=",eventName);
        this.emmiter.on(eventName, callback, context);

        this._addToSubscribersLog()
    }

    unsubscribe(context:any) {
        if (!context) {
            console.error("EventsBus: unsubscribe without context will unsubscribe All events!");
            return
        }

        if (debug.monitor) console.log(debug.head,".off",context);
        this.emmiter.off(null,null,context);

        this._removeFromSubscribersLog()
    }

    unsubscribeFromEvent(eventName:string, context:any) {
        if (!context) {
            console.error("EventsBus: unsubscribe without context will unsubscribe All events!");
            return
        }

        if (debug.monitor) console.log(debug.head,".off",context);
        this.emmiter.off(eventName,null,context);

        this._removeFromSubscribersLog()
    }

    _addToSubscribersLog() {
        if (!debugEvents) return

        const newMap: any = {}
        _.forEach(this.emmiter._events, (subscribers, eventName)=>{
            if (!newMap[eventName]) newMap[eventName] = []

            _.map(subscribers, subscriber=>{
                newMap[eventName].push(subscriber)
            })

            // there may be only one subscriber added
            const added     = _.difference(newMap[eventName], this.debugEventsMap[eventName])[0]
            if (!_.isEmpty(added)) {
                const debugEntry = {
                    moment      : moment().format('YYYY-MM-DD HH:mm:ss.SSS'),
                    eventName   : eventName,
                    caller      : getStackTrace(),
                    subscriber  : added
                }
                this.debugEntries.push(debugEntry)

                // console.log("_addToSubscribersLog", eventName, debugEntry, added)
            }
        })

        this.debugEventsMap = newMap
    }

    _removeFromSubscribersLog() {
        if (!debugEvents) return

        const newMap: any = {}
        let eventNames: string[] = []
        _.forEach(this.emmiter._events, (subscribers, eventName)=>{
            if (!newMap[eventName]) newMap[eventName] = []

            _.map(subscribers, subscriber=>{
                newMap[eventName].push(subscriber)
            })

            eventNames.push(eventName)
        })

        _.forEach(this.debugEventsMap, (subscribers, eventName)=>{
            eventNames.push(eventName)
        })

        eventNames = _.uniq(eventNames)

        _.map(eventNames, (eventName)=>{
            // there may be deleted many subscribers at once
            const deleted   = _.difference(this.debugEventsMap[eventName], newMap[eventName])
            if (!_.isEmpty(deleted)) {
                const debugEntries = _.remove(this.debugEntries, (debugEntry:DebugEntry)=>{
                    return !!_.find(deleted, subscriber=>subscriber === debugEntry.subscriber)
                })

                // console.log("_removeFromSubscribersLog", eventName, debugEntries, deleted)
            }
        })

        this.debugEventsMap = newMap
    }

    debugEvents() {
        if (!debugEvents) {
            // console.log("EventsBus: debugEvents is disabled")
            return
        }

        /*const newMap: any = {}
        const diffMap: any = {}

        // collect all added/deleted/remain events between calls of debugEvents
        _.forEach(this.emmiter._events, (subscribers, key)=>{
            if (!newMap[key]) newMap[key] = []

            _.map(subscribers, subscriber=>{
                newMap[key].push(subscriber)
            })

            const added     = _.difference(newMap[key], this.debugEventsMap[key])
            const deleted   = _.difference(this.debugEventsMap[key], newMap[key])
            const remain    = _.intersection(this.debugEventsMap[key], newMap[key])

            diffMap[key] = {added, deleted, remain}
        })

        console.log("debugEvents diffMap", diffMap)

        // save for further comparison
        this.debugEventsMap = newMap
        // add differences map to array of results for each debugEvents call
        this.diffMapIterations.push(diffMap)

        // collect subscriptions that are still remain after all debugEvents call iterations
        const remainMap: any = {}
        _.map(this.diffMapIterations, iteration=>{
            _.forEach(iteration, (diff, key)=>{
                if(!remainMap[key]) {
                    remainMap[key] = diff.added
                } else {
                    remainMap[key] = _.union(remainMap[key], diff.added)
                    remainMap[key] = _.difference(remainMap[key], diff.deleted)
                }
            })
        })

        // remove all that were added on first run (that should probably never be removed)
        _.forEach(_.first(this.diffMapIterations), (diff, key)=>{
            remainMap[key] = _.difference(remainMap[key], diff.added)
        })

        console.log("debugEvents remainMap", this.diffMapIterations.length, remainMap, _.pickBy(remainMap, value=>!_.isEmpty(value)))*/

        const groupedDebugEntries = _(this.debugEntries)
            .groupBy(debugEntry=>debugEntry.eventName)
            .value()

        console.log("EventsBus debugEntries", this.debugEntries, groupedDebugEntries, this.emmiter._events)
    }

    debug() {
        console.log("debug ", this.emmiter._events, this.emmiter)

        let totalEventListeners : number = 0

        _.forEach(this.emmiter._events, (value, key)=>{
            const listeners = _.size(value)
            console.log(key, listeners)
            totalEventListeners += listeners
        })

        console.log("TOTAL = ", totalEventListeners)

    }

    get totalListeners():number {

        let totalEventListeners : number = 0

        _.forEach(this.emmiter._events, (value, key)=>{
            const listeners = _.size(value)
            // console.log(key, listeners)
            totalEventListeners += listeners
        })

        return totalEventListeners

    }

};
